import React from 'react'
import TabLinkUI from '../../../../widgets/output/TabLinkUI'

const TokensNavUI = ({ context, loan, page }) =>
  <div>
    <div className='g_flex_h g_flex_left g_flex_wrap'>
      <TabLinkUI label='System generated tokens' to={`/su/loans/${loan.loanId}/tokenS`} active={page === 'tokenS'} />
      <TabLinkUI label='General tokens' to={`/su/loans/${loan.loanId}/tokenUW`} active={page === 'tokenG'} />
      <TabLinkUI label='Transaction tokens' to={`/su/loans/${loan.loanId}/tokenL`} active={page === 'tokenT'} />
    </div>
    <div className='g_m_top_50' />
  </div>

export default TokensNavUI